import styles from "./loader.module.css"

export const Loader = () => {
    return (
        <svg className={styles.loader} width="48" height="48" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle 
                r="3.5"
                cx="5" cy="5"
                strokeWidth="1.2"
                strokeLinecap="round"
                stroke="var(--app-accent-color)"
                strokeDasharray="19"
                strokeDashoffset="3"
            />
        </svg>
    )
}
